import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { skipLoader } from '@rsm/shared/loader';
import { environment } from 'src/environments/environment';

/**
 *
 */
@Injectable({
  providedIn: 'root',
})
export class AuthClientService {
  /**
   * @param http
   */
  constructor(private http: HttpClient) {}

  /**
   * @param credentail
   * @returns
   */
  public login(credentail: any): Observable<any> {
    const { login, password } = credentail;

    return this.http.post<any>(`${environment.auth.url}/auth/login`, {
      login,
      password,
      sourceApp: false,
      grantType: 'password',
      applicationScope: 'mission',
      scopes: ['mission', 'security', 'agent'],
    });
  }

  /**
   * @param credentail
   * @param options `silent: true` para a renovação automática de sessão, que
   * roda em segundo plano e não deve bloquear a tela com o overlay de
   * carregamento. Trocas de contexto disparadas pelo usuário seguem com o
   * overlay, porque ele precisa saber que a aplicação está trabalhando.
   * @returns
   */
  public refresh(credentail: any, options?: { silent?: boolean }): Observable<any> {
    const { refreshToken, userContextId } = credentail;

    return this.http.post<any>(
      `${environment.auth.url}/auth/refresh`,
      {
        refreshToken,
        userContextId,
        scopes: ['mission', 'security', 'agent'],
      },
      options?.silent ? { context: skipLoader() } : {}
    );
  }

  /**
   * @returns
   */
  public findAllContexts(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.auth.url}/auth/user-request/contexts`
    );
  }

  /**
   * @param data
   * @returns
   */
  public changePassword(data: any): Observable<any> {
    return this.http.put<any>(`${environment.auth.url}/users/password`, data);
  }

  /**
   *
   * @param email
   * @returns
   */
  public recoverPassword(email: string): Observable<any> {
    let params: HttpParams = new HttpParams();

    if (email) {
      params = params.append('email', email);
    }

    return this.http.get(
      `${environment.auth.url}/auth/user-request/recover-password`,
      { params }
    );
  }

  public validateRequestToken(requestToken: string): Observable<any> {
    let params: HttpParams = new HttpParams();

    if (requestToken) {
      params = params.append('requestToken', requestToken);
    }

    return this.http.get(
      `${environment.auth.url}/auth/user-request/token`,
      { params }
    );
  }

  public validateManagerToken(requestToken: string): Observable<any> {
    let params: HttpParams = new HttpParams();

    if (requestToken) {
      params = params.append('requestToken', requestToken);
    }

    return this.http.get(
      `${environment.auth.url}/auth/user-request/manager-token`,
      { params }
    );
  }
}
